import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Slide,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { IoCloseOutline } from "react-icons/io5";
import Constants from "data/Constants";
import { useFormik } from "formik";
import * as yup from "yup";
import Utils from "utils/index";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const defaultSubscription = {
  _id: "T" + Utils.uniqueId(),
  _new: true,
  months: "",
  costPrice: "",
  salePrice: "",
};

function SubscriptionDialog(props) {
  const { subscription, onClose, onChange } = props;
  const [data, setData] = useState(subscription);

  const validationSchema = yup.object({
    months: yup.number().required().label("Subscription Months").min(1).max(12),
    costPrice: yup.number().required().label("Cost Price"),
    salePrice: yup
      .number()
      .required()
      .label("Sale Price")
      .when(["costPrice"], (costPrice) => {
        return yup
          .number()
          .required()
          .label("Sale Price")
          .max(
            costPrice,
            "Sale Price should be less than or equal to Cost Price"
          );
      }),
  });

  const subscriptionData = {
    months: subscription.days / Constants.MONTH_SIZE,
    costPrice: subscription.costPrice,
    salePrice: subscription.salePrice,
  };

  const formik = useFormik({
    initialValues: subscriptionData,
    validationSchema,
    onSubmit: (values) => {
      onChange({
        days: values.months * Constants.MONTH_SIZE,
        friendlyTime:
          values.months + " Month" + (values.months == 1 ? "" : "s"),
        costPrice: values.costPrice,
        salePrice: values.salePrice,
        _id: subscription._id,
        _new: subscription._new,
      });

      onClose();
    },
  });

  const inputChangeHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setData(subscription);
  }, [subscription]);

  return subscription ? (
    <Dialog
      open={subscription ? true : false}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <Box flexGrow={1} className="font-extrabold text-lg">
              Subscription
            </Box>
            <Box>
              <IconButton onClick={onClose}>
                <IoCloseOutline />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          <div className="grid" style={{ minWidth: "450px" }}>
            <TextField
              label="Subscription Months"
              variant="filled"
              name="months"
              value={formik.values.months}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.months && Boolean(formik.errors.months)}
              helperText={formik.touched.months && formik.errors.months}
              required
              size="small"
              type="number"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">Months</InputAdornment>
                ),
              }}
            />

            <TextField
              label="Subscription Cost Price"
              variant="filled"
              size="small"
              type="number"
              value={formik.values.costPrice}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.costPrice && Boolean(formik.errors.costPrice)
              }
              helperText={formik.touched.costPrice && formik.errors.costPrice}
              required
              name="costPrice"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {Constants.CURRENCY_SYMBOL}
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              label="Subscription Sale Price"
              variant="filled"
              type="number"
              size="small"
              name="salePrice"
              value={formik.values.salePrice}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.salePrice && Boolean(formik.errors.salePrice)
              }
              helperText={formik.touched.salePrice && formik.errors.salePrice}
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {Constants.CURRENCY_SYMBOL}
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button size="small" onClick={onClose}>
            Cancel
          </Button>
          <Button size="small" type="submit">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  ) : (
    ""
  );
}

export default SubscriptionDialog;
